var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 76,
    viewBox: "0 0 55 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_4176_21313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 50.5693C41.3071 50.5693 52.5 39.3765 52.5 25.5693C52.5 11.7622 41.3071 0.569336 27.5 0.569336C13.6929 0.569336 2.5 11.7622 2.5 25.5693C2.5 39.3765 13.6929 50.5693 27.5 50.5693Z",
    fill: "#D9D9D9",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2958 16.7464C31.8709 18.1393 38.6916 15.3268 38.1165 13.9338C37.5415 12.5408 35.5488 12.0398 33.6662 12.8179C31.7836 13.5941 30.7208 15.3534 31.2958 16.7464Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3248 16.7464C23.7498 18.1393 16.9291 15.3268 17.5041 13.9338C18.0791 12.5408 20.0718 12.0398 21.9545 12.8179C23.8371 13.5941 24.8999 15.3534 24.3248 16.7464Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9036 20.9636C23.0401 19.8629 21.4403 20.0717 20.1308 21.3641C18.8706 20.233 17.4169 20.0584 16.6312 21.0585C15.7013 22.2447 16.06 24.6245 17.434 26.3762C18.4683 27.6933 19.7797 28.2778 20.7627 27.9836C21.5712 27.8527 22.4461 27.3042 23.1749 26.3762C24.5489 24.6245 24.8753 22.201 23.9036 20.9636Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0862 20.9636C38.2227 19.8629 36.6229 20.0717 35.3134 21.3641C34.0532 20.233 32.5995 20.0584 31.8138 21.0585C30.8839 22.2447 31.2426 24.6245 32.6166 26.3762C33.6509 27.6933 34.9623 28.2778 35.9454 27.9836C36.7538 27.8527 37.6287 27.3042 38.3575 26.3762C39.7315 24.6245 40.0579 22.201 39.0862 20.9636Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2225 24.692C37.8734 24.692 38.401 24.1644 38.401 23.5135C38.401 22.8626 37.8734 22.335 37.2225 22.335C36.5716 22.335 36.0439 22.8626 36.0439 23.5135C36.0439 24.1644 36.5716 24.692 37.2225 24.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0399 24.692C22.6908 24.692 23.2184 24.1644 23.2184 23.5135C23.2184 22.8626 22.6908 22.335 22.0399 22.335C21.389 22.335 20.8613 22.8626 20.8613 23.5135C20.8613 24.1644 21.389 24.692 22.0399 24.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0648 37.1968C23.6871 37.3809 28.0692 47.0654 32.2443 36.8059C32.2443 36.8059 27.5947 35.2041 27.7845 32.9268C27.7845 32.9268 28.1261 35.2041 24.0648 37.1968Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1248 30.7386C31.1248 28.7004 23.7461 28.7004 23.7461 30.7386C23.7461 32.7769 25.3972 34.428 27.4354 34.428C29.4737 34.428 31.1248 32.7769 31.1248 30.7386Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 33.8281C15.1582 33.8281 21.4798 41.5105 26.8658 34.4278",
    stroke: "#757575",
    strokeWidth: 1.13869,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1055 33.8281C28.1055 33.8281 34.4271 41.5105 39.8131 34.4278",
    stroke: "#757575",
    strokeWidth: 1.13869,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37603 31.5984C11.8915 31.5984 13.9308 30.4938 13.9308 29.1312C13.9308 27.7686 11.8915 26.6641 9.37603 26.6641C6.86052 26.6641 4.82129 27.7686 4.82129 29.1312C4.82129 30.4938 6.86052 31.5984 9.37603 31.5984Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0987 31.6931C48.6142 31.6931 50.6534 30.5885 50.6534 29.2259C50.6534 27.8634 48.6142 26.7588 46.0987 26.7588C43.5832 26.7588 41.5439 27.8634 41.5439 29.2259C41.5439 30.5885 43.5832 31.6931 46.0987 31.6931Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9461 25.25L23.8945 28.6053",
    stroke: "#D9D9D9",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6023 25.25L26.5508 28.6053",
    stroke: "#D9D9D9",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2595 25.25L29.208 28.6053",
    stroke: "#D9D9D9",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 64.625V65.7734H16.4844V66.6758H6.875V65.7734H11.1172V64.625H12.2188ZM15.6055 61.8008V62.6562H12.4297C12.6055 63.5645 14.082 64.2852 15.9805 64.4141L15.6172 65.2461C13.7656 65.0879 12.2305 64.4141 11.6797 63.3594C11.123 64.4141 9.58203 65.0879 7.73047 65.2461L7.36719 64.4141C9.23047 64.2852 10.7305 63.5645 10.918 62.6562H7.76562V61.8008H15.6055ZM15.5703 67.9648V68.8203H7.76562V67.9648H11.1172V67.0391H12.2188V67.9648H15.5703ZM11.6562 69.2656C13.6953 69.2656 14.8672 69.7461 14.8672 70.6484C14.8672 71.5625 13.6953 72.043 11.6562 72.043C9.61719 72.043 8.48047 71.5625 8.48047 70.6484C8.48047 69.7461 9.61719 69.2656 11.6562 69.2656ZM11.6562 70.0273C10.3438 70.0273 9.60547 70.2266 9.61719 70.6484C9.60547 71.0703 10.3438 71.293 11.6562 71.2812C12.9922 71.293 13.707 71.0703 13.7188 70.6484C13.707 70.2266 12.9922 70.0273 11.6562 70.0273ZM19.9983 62.2812C21.5686 62.2812 22.6819 63.7109 22.6936 65.9609C22.6819 68.2227 21.5686 69.6523 19.9983 69.6523C18.428 69.6523 17.303 68.2227 17.3147 65.9609C17.303 63.7109 18.428 62.2812 19.9983 62.2812ZM19.9983 63.2773C19.0374 63.2773 18.3811 64.3086 18.3811 65.9609C18.3811 67.625 19.0374 68.6562 19.9983 68.6562C20.971 68.6562 21.6272 67.625 21.6272 65.9609C21.6272 64.3086 20.971 63.2773 19.9983 63.2773ZM25.3655 61.4961V65.6094H27.053V66.5469H25.3655V71.9961H24.2522V61.4961H25.3655ZM32.6763 63.2305V64.1328H27.4615V63.2305H29.524V61.8008H30.6255V63.2305H32.6763ZM30.0748 64.7656C31.4107 64.7656 32.3482 65.7617 32.3599 67.1797C32.3482 68.6094 31.4107 69.6172 30.0748 69.6172C28.7623 69.6172 27.7896 68.6094 27.8013 67.1797C27.7896 65.7617 28.7623 64.7656 30.0748 64.7656ZM30.0748 65.6914C29.313 65.6914 28.7857 66.3125 28.7857 67.1797C28.7857 68.0703 29.313 68.668 30.0748 68.668C30.8248 68.668 31.3755 68.0703 31.3755 67.1797C31.3755 66.3125 30.8248 65.6914 30.0748 65.6914ZM36.4732 61.4961V71.9961H35.4185V66.7812H34.2115V71.5039H33.1568V61.7305H34.2115V65.8672H35.4185V61.4961H36.4732ZM47.3934 69.7578V70.6836H37.784V69.7578H40.0809V67.0156C39.2195 66.541 38.6981 65.7852 38.6981 64.8477C38.6981 63.1953 40.3153 62.1055 42.5653 62.1055C44.827 62.1055 46.4442 63.1953 46.4442 64.8477C46.4442 65.7734 45.9403 66.5176 45.0965 66.9922V69.7578H47.3934ZM42.5653 62.9961C40.9129 62.9961 39.7762 63.7109 39.7762 64.8477C39.7762 65.9727 40.9129 66.7109 42.5653 66.7109C44.2059 66.7109 45.366 65.9727 45.366 64.8477C45.366 63.7109 44.2059 62.9961 42.5653 62.9961ZM41.1824 69.7578H43.9715V67.4141C43.5438 67.5254 43.0692 67.5781 42.5653 67.5781C42.0731 67.5781 41.6043 67.5254 41.1824 67.4258V69.7578Z",
    fill: "#C5C5C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4176_21313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourInactive);
export default __webpack_public_path__ + "static/media/fourInactive.8715b8c208a6056e63c75024977c76b8.svg";
export { ForwardRef as ReactComponent };